import type { RootState } from '@/app/store';

// Basic selectors
export const selectFacilityByIdData = (state: RootState) =>
  state.facilities.facilityDetailData;
export const selectFacilityByIdLoading = (state: RootState) =>
  state.facilities.loading;
export const selectFacilityByIdError = (state: RootState) =>
  state.facilities.error;
export const selectFacilitiesStatusData = (state: RootState) =>
  state.facilities.facilitiesStatusData;
export const selectFacilitiesStatusLoading = (state: RootState) =>
  state.facilities.loading;
export const selectFacilitiesStatusError = (state: RootState) =>
  state.facilities.error;
